import { render } from "./privateLetter.vue?vue&type=template&id=4e83161c&scoped=true"
import script from "./privateLetter.vue?vue&type=script&lang=js"
export * from "./privateLetter.vue?vue&type=script&lang=js"

import "./privateLetter.vue?vue&type=style&index=0&id=4e83161c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e83161c"]])

export default __exports__